
// ***NOTE*** Please preserve alphabetical order when adding new icons
export {
  faArrowCircleLeft,
  faArrowRight,
  faArrowUp,
  faBackspace,
  faBan,
  faBars,
  faBell,
  faBuilding,
  faCaretDown,
  faChartBar,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCity,
  faClipboard,
  faClock,
  faCog,
  faComment,
  faCommentAlt,
  faCreditCard,
  faDotCircle,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFileExport,
  faHome,
  faInfoCircle,
  faLink,
  faMapMarkerAlt,
  faMinus,
  faMinusSquare,
  faMoneyCheckAlt,
  faPaperclip,
  faPencilAlt,
  faPlus,
  faQuestionCircle,
  faSave,
  faSearch,
  faSitemap,
  faSortUp,
  faSpinner,
  faSyncAlt,
  faTag,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUser,
  faUserEdit,
  faUserPlus,
  faUsers,
  faUserSlash,
  faUserTag,
} from '@fortawesome/free-solid-svg-icons'
